// Small helper to render JSON-LD structured data in the head.
import { useEffect } from "react";

export function JsonLd({ data, id }) {
    const json = typeof data === "string" ? data : JSON.stringify(data);
    useEffect(() => {
        if (typeof document === "undefined") return undefined;
        const elId = id || `jsonld-${json.length}`;
        let el = document.getElementById(elId);
        if (!el) {
            el = document.createElement("script");
            el.type = "application/ld+json";
            el.id = elId;
            document.head.appendChild(el);
        }
        el.textContent = json;
        return () => {
            const cleanup = document.getElementById(elId);
            if (cleanup) cleanup.remove();
        };
    }, [json, id]);
    return null;
}
